import { render, staticRenderFns } from "./BVListForm.vue?vue&type=template&id=56028d42"
import script from "./BVListForm.vue?vue&type=script&lang=js"
export * from "./BVListForm.vue?vue&type=script&lang=js"
import style0 from "./BVListForm.vue?vue&type=style&index=0&id=56028d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports